import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-32 overflow-hidden" data-id="element-31">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-32">
        <img src="https://images.unsplash.com/photo-1565299585323-38d6b0865b47?auto=format&fit=crop&q=80&w=2000" alt="Mexican food background" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-33" />
        <div className="absolute inset-0 bg-gradient-to-t from-burgundy-dark via-burgundy-dark/90 to-burgundy-dark/70 mix-blend-multiply" data-id="element-34" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-36">
          <h2 className="font-display text-4xl md:text-6xl font-black text-cream leading-tight mb-6 drop-shadow-lg" data-id="element-37">
            EL VERDADERO SABOR MEXICANO TE ESTÁ ESPERANDO
          </h2>

          <p className="font-script text-3xl md:text-4xl text-orange-light mb-12 drop-shadow-md" data-id="element-38">
            Ordena hoy y disfruta comida fresca, auténtica y hecha con pasión.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-39">
            <a href="tel:+12522131970" className="group flex items-center justify-center gap-3 bg-orange hover:bg-orange-light text-white w-full sm:w-auto px-10 py-5 rounded-full font-bold text-lg tracking-wider transition-all shadow-[0_0_20px_rgba(232,115,44,0.3)] hover:shadow-[0_0_30px_rgba(232,115,44,0.5)] hover:-translate-y-1" data-id="element-40">
              <Phone size={24} className="group-hover:rotate-12 transition-transform" data-id="element-41" />
              <span data-id="element-42">LLAMAR AHORA</span>
            </a>
            <a href="#menu" className="group flex items-center justify-center gap-3 bg-transparent border-2 border-cream/80 hover:border-cream text-cream w-full sm:w-auto px-10 py-5 rounded-full font-bold text-lg tracking-wider transition-all hover:bg-cream/10" data-id="element-43">
              <span data-id="element-44">VER MENÚ</span>
              <ArrowRight size={24} className="group-hover:translate-x-1 transition-transform" data-id="element-45" />
            </a>
          </div>

          <div className="mt-12 inline-block bg-black/40 backdrop-blur-sm border border-cream/10 rounded-full px-8 py-3" data-id="element-46">
            <div className="flex items-center gap-3 text-cream font-bold text-xl tracking-widest" data-id="element-47">
              <Phone size={20} className="text-orange" data-id="element-48" />
              <span data-id="element-49">(252) 213-1970</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}